import React, { useEffect, useState } from "react";
import "./Signupnew.scss";
import "./styles.css";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CancelIcon } from "../../common/assets/svg/cancelIconnew.svg";
import DesktopSignupPopup from '../../components/DesktopSignupModal/DesktopSignupModal'
import SigninScreen from "./SigninScreen";
import OtpScreenNew from "./OtpScreenNew";
import UpdateUserDetails from "./UpdateUserDetails";
import { ACCESS_TOKEN, SERVERKNOWNSALT, USER_DETAILS, USER_ID } from "../../common/constants";
import { deleteCookie, getCookie } from "../../helper/cookieHelper";
import { getOtpRequest } from "../../common/features/auth/AuthActions";

// import SignInForm from "../SignInForm/SignInForm";
interface signinprops {
  isOpen: any;
  onClose: any;
  setSigninOrOtp?: React.Dispatch<React.SetStateAction<string>>
  signInPopupDesktop?: boolean
  forceProfileCompletion?: boolean

}
const signInScreens = {
  SIGNIN: "signin",
  OTP: "otp",
  UPDATE_USER: "EditProfile"
}

  const SiginInContainer: React.FC<signinprops> = ({
    isOpen,
    onClose,
    setSigninOrOtp,
    signInPopupDesktop,
    forceProfileCompletion = false,
  }) => {
  const dispatch = useDispatch();
  const verifyOtpSuccess = useSelector((state: any) => state.auth.verifyOtpSuccess);
  const verifyOtpMessage = useSelector((state: any) => state.auth.verifyOtpMessage);
  const countryData = useSelector((state: any) => state.user.countryData);
  const [data, setdata] = useState<any>({});

  // Use countryData.code instead of separate countryCode state
  const isMobile = useSelector((state: any) => state?.navigation?.isMobile)
  const [isViewportMobile, setIsViewportMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );
  const isMobileView = isMobile || isViewportMobile;
  const useDesktopPopup = !!signInPopupDesktop && !isMobileView;

  const getOtpLoading = useSelector((state: any) => state.auth.getOtpLoading)
  const getOtpSuccess = useSelector((state: any) => state.auth.getOtpSuccess);
  const getOtpFailure = useSelector(
    (state: any) => state.auth.getOtpFailure
  );

  const userData = useSelector((state: any) => state.auth.userData) || {};
  // console.log("userDataCookie 4",userData)        
  // const userDataLocal = useSelector((state: any) => state.auth.userData)|| JSON.parse(localStorage.getItem(USER_DETAILS)||"{}");
  useEffect(() => {
    if (getOtpSuccess) {
      setCurrentScreen(signInScreens?.OTP)
    }
  }, [getOtpSuccess])

  useEffect(() => {
    if (!userData?.customerId) {
      setCurrentScreen(signInScreens?.SIGNIN)
    }
  }, [userData])

  useEffect(() => {
    if (!isOpen) return;
    try {
      const cdUser = JSON.parse(localStorage.getItem('CDUSER') || '{}');
      if (cdUser?.mobileNumber) {
        const parts = (cdUser.mobileNumber as string).split('-');
        const numberOnly = parts.length > 1 ? parts[parts.length - 1] : cdUser.mobileNumber;
        setdata({ inputData: numberOnly });
        dispatch(getOtpRequest({ mobilePhone: cdUser.mobileNumber, sendOtpViaEmail: false }));
        setCurrentPage(signInScreens.OTP);
        setCurrentScreen(signInScreens.OTP);
      }
    } catch { /* ignore */ }
  }, [isOpen])


  useEffect(() => {
    // Only auto-close if the component is actually open AND userData exists in cookies (not just Redux state)
    // After 403/401, cookies are deleted, so getCookie will return null even if Redux state has old data
    const userDataFromCookie = getCookie(USER_DETAILS);
    if (verifyOtpSuccess && isOpen && userDataFromCookie?.customerId) {
      const isProfileComplete = Boolean(
        userDataFromCookie?.mobilePhone &&
          (userDataFromCookie?.firstName || userDataFromCookie?.name) &&
          userDataFromCookie?.email
      );
      if (!isProfileComplete) {
        setCurrentScreen(signInScreens?.UPDATE_USER)
        setCurrentPage(signInScreens?.UPDATE_USER)
      } else {
        setCurrentScreen(signInScreens?.SIGNIN)
        setCurrentPage(signInScreens?.SIGNIN)
        //  setCurrentScreen(signInScreens?.UPDATE_USER)
        onClose()
      }
    }
  }, [verifyOtpSuccess, isOpen])

  useEffect(() => {
    if (!isOpen) return;
    if (!forceProfileCompletion) return;

    const userDataFromCookie = getCookie(USER_DETAILS) || {};
    if (userDataFromCookie?.customerId) {
      setCurrentScreen(signInScreens.UPDATE_USER);
      setCurrentPage(signInScreens.UPDATE_USER);
    }
  }, [isOpen, forceProfileCompletion]);




  const [currentScreen, setCurrentScreen] = useState("signin");
  const [currentPage, setCurrentPage] = useState("signin");

  useEffect(() => {
    if (currentScreen === signInScreens.OTP) {
      setSigninOrOtp && setSigninOrOtp("Enter OTP");
    } else if (currentScreen === signInScreens.UPDATE_USER) {
      setSigninOrOtp && setSigninOrOtp("Sign Up");
    } else {
      setSigninOrOtp && setSigninOrOtp("Sign In");
    }

  }, [currentScreen])

  useEffect(() => {
    const handleResize = () => setIsViewportMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const lockScroll = () => {
      document.body.classList.add("no-scroll");
      document.documentElement.classList.add("no-scroll");
    };

    const unlockScroll = () => {
      document.body.classList.remove("no-scroll");
      document.documentElement.classList.remove("no-scroll");
    };

    if (currentPage === signInScreens?.SIGNIN || currentPage === signInScreens?.OTP || currentPage === signInScreens?.UPDATE_USER) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return () => {
      unlockScroll();
    };
  }, [currentPage]);

  if (!isOpen) return null;

  const handleSignInClose = () => {
    onClose();
  }

  const handleSignSubmit = () => {
    setCurrentPage(signInScreens?.OTP)
  }

  const handleOtpClose = (forceClose?: boolean) => {
    if (forceClose) {
      onClose();
      return;
    }

    const isProfileComplete = Boolean(
      verifyOtpMessage?.mobilePhone &&
        (verifyOtpMessage?.firstName || verifyOtpMessage?.name) &&
        verifyOtpMessage?.email
    );
    if (!isProfileComplete) {
      setCurrentScreen(signInScreens?.UPDATE_USER);
      setCurrentPage(signInScreens?.UPDATE_USER);
      return;
    }

    onClose();
  }
  const hanldeDesktopPopupSignUP = (shouldClearAuth = true) => {
    onClose();
    if (shouldClearAuth) {
      deleteCookie(USER_ID);
      deleteCookie(USER_DETAILS);
      deleteCookie(ACCESS_TOKEN);
         deleteCookie(SERVERKNOWNSALT);
    } 
    //  setCurrentScreen(signInScreens.SIGNIN);  
  }



  const handleVerifySubmit = () => {
    const userDataFromCookie = getCookie(USER_DETAILS);
    const isProfileComplete = Boolean(
      userDataFromCookie?.mobilePhone &&
        (userDataFromCookie?.firstName || userDataFromCookie?.name) &&
        userDataFromCookie?.email
    );
    if (userData?.customerId && isProfileComplete) {
      setCurrentScreen(signInScreens.SIGNIN);
      onClose();
    } else {
      setCurrentScreen(signInScreens.UPDATE_USER);
      setCurrentPage(signInScreens.UPDATE_USER);
    }
  }

  return (
    <>
      {/* {currentScreen === signInScreens?.SIGNIN? <SigninScreen handleOnSubmit={handleSignInClose} onClose={handleSignInClose} /> : (currentScreen === signInScreens?.OTP ? <OtpScreenNew setCurrentScreen={setCurrentScreen} onClose={handleOtpClose} /> : (currentScreen === signInScreens?.UPDATE_USER ? <UpdateUserDetails onClose={onClose} /> : null))} */}

      <div
        className={signInPopupDesktop ? "user-Signin-container-overlay" : ""}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <div
          className={signInPopupDesktop ? currentPage === signInScreens?.OTP ? "user-otp-container" : (currentPage === signInScreens?.UPDATE_USER) ? "user-DesktopView-container" : "user-Signin-container" : "usercontainer-checkoutpage"}
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          {signInPopupDesktop && <CancelIcon className="close-btnZa-Desktop-signup"
            onClick={() => {
              if (currentScreen === signInScreens?.SIGNIN) {
                handleSignInClose();
              } else if (currentScreen === signInScreens?.OTP) {
                handleOtpClose(true);
              } else {
                hanldeDesktopPopupSignUP();
              }
            }} />}

          {
            currentPage === signInScreens?.SIGNIN ?
              <SigninScreen
                handleOnSubmit={handleSignSubmit}
                onClose={handleSignInClose}
                isMobile={isMobileView}
                signInPopupDesktop={useDesktopPopup}
                setdata={setdata}
              />
              //  <UpdateUserDetails onClose={onClose} countryData={countryData} data={data} isMobile={isMobile} signInPopupDesktop={signInPopupDesktop} setCurrentPage={setCurrentPage} />
              // <DesktopSignupPopup isOpen={signInPopupDesktop} onClose={hanldeDesktopPopupSignUP} setCurrentPage={setCurrentPage} />

              :
              currentPage === signInScreens?.OTP ?
                <OtpScreenNew
                  handleVerifySubmit={handleVerifySubmit}
                  onClose={handleOtpClose}
                  setCurrentPage={setCurrentPage}
                  userData={userData}
                  isMobile={isMobileView}
                  signInPopupDesktop={useDesktopPopup}
                  countryData={countryData}
                  data={data}
                /> :
                currentPage === signInScreens?.UPDATE_USER ?
                  useDesktopPopup ?
                    <DesktopSignupPopup
                      isOpen={useDesktopPopup}
                      onClose={() => hanldeDesktopPopupSignUP(false)}
                      setCurrentPage={setCurrentPage}
                      data={data}
                    /> :
                    <UpdateUserDetails
                      onClose={onClose}
                      countryData={countryData}
                      data={data}
                      isMobile={isMobileView}
                      signInPopupDesktop={useDesktopPopup}
                      setCurrentPage={setCurrentPage}
                    /> : <></>
          }

        </div>
      </div>

    </>
  );
};

export default SiginInContainer;
